var render = function render(){var _vm=this,_c=_vm._self._c;return _c('register-container',[_c('template',{slot:"header"},[_vm._v(" ("+_vm._s(_vm.errorCode)+") "+_vm._s(this.$t(`notFound.${_vm.errorCode}`)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }